import { defineComponent as he, toRef as me, ref as P, watch as ve, onBeforeUnmount as we, inject as pe, computed as ge, h as i, Fragment as K, withDirectives as q, Transition as Y, vShow as xe, normalizeStyle as be } from "vue";
import { prevIcon as Ce, nextIcon as Se, downloadIcon as ke, closeIcon as Pe } from "./ghl-ui.es1374.js";
import { imagePreviewSharedProps as Ie, imageContextKey as ye } from "./ghl-ui.es1045.js";
import Re from "./ghl-ui.es1375.js";
import Me from "./ghl-ui.es879.js";
import { imageLight as De } from "./ghl-ui.es1376.js";
import Oe from "./ghl-ui.es943.js";
import { on as $, off as y } from "./ghl-ui.es724.js";
import ze from "./ghl-ui.es878.js";
import { useThemeClass as Te } from "./ghl-ui.es881.js";
import He from "./ghl-ui.es727.js";
import We from "./ghl-ui.es788.js";
import w from "./ghl-ui.es886.js";
import Xe from "./ghl-ui.es1377.js";
import Ye from "./ghl-ui.es1378.js";
import $e from "./ghl-ui.es1379.js";
import _e from "./ghl-ui.es1380.js";
import Be from "./ghl-ui.es1381.js";
import Ne from "./ghl-ui.es733.js";
import Le from "./ghl-ui.es1318.js";
import Ee from "./ghl-ui.es399.js";
import { beforeNextFrameOnce as Ve } from "./ghl-ui.es1357.js";
import { download as Ae } from "./ghl-ui.es986.js";
const R = 32, mt = he({
  name: "ImagePreview",
  props: Object.assign(Object.assign({}, Ie), {
    onNext: Function,
    onPrev: Function,
    clsPrefix: {
      type: String,
      required: !0
    }
  }),
  setup(a) {
    const b = Me("Image", "-image", Re, De, a, me(a, "clsPrefix"));
    let r = null;
    const v = P(null), s = P(null), M = P(void 0), I = P(!1), D = P(!1), {
      localeRef: G
    } = Oe("Image");
    function J() {
      const {
        value: e
      } = s;
      if (!r || !e)
        return;
      const {
        style: o
      } = e, t = r.getBoundingClientRect(), n = t.left + t.width / 2, l = t.top + t.height / 2;
      o.transformOrigin = `${n}px ${l}px`;
    }
    function O(e) {
      var o, t;
      switch (e.key) {
        case " ":
          e.preventDefault();
          break;
        case "ArrowLeft":
          (o = a.onPrev) === null || o === void 0 || o.call(a);
          break;
        case "ArrowRight":
          (t = a.onNext) === null || t === void 0 || t.call(a);
          break;
        case "Escape":
          j();
          break;
      }
    }
    ve(I, (e) => {
      e ? $("keydown", document, O) : y("keydown", document, O);
    }), we(() => {
      y("keydown", document, O);
    });
    let _ = 0, B = 0, g = 0, x = 0, z = 0, T = 0, N = 0, L = 0, H = !1;
    function E(e) {
      const {
        clientX: o,
        clientY: t
      } = e;
      g = o - _, x = t - B, Ve(h);
    }
    function Q(e) {
      const {
        mouseUpClientX: o,
        mouseUpClientY: t,
        mouseDownClientX: n,
        mouseDownClientY: l
      } = e, f = n - o, u = l - t, m = `vertical${u > 0 ? "Top" : "Bottom"}`, p = `horizontal${f > 0 ? "Left" : "Right"}`;
      return {
        moveVerticalDirection: m,
        moveHorizontalDirection: p,
        deltaHorizontal: f,
        deltaVertical: u
      };
    }
    function V(e) {
      const {
        value: o
      } = v;
      if (!o)
        return {
          offsetX: 0,
          offsetY: 0
        };
      const t = o.getBoundingClientRect(), {
        moveVerticalDirection: n,
        moveHorizontalDirection: l,
        deltaHorizontal: f,
        deltaVertical: u
      } = e || {};
      let m = 0, p = 0;
      return t.width <= window.innerWidth ? m = 0 : t.left > 0 ? m = (t.width - window.innerWidth) / 2 : t.right < window.innerWidth ? m = -(t.width - window.innerWidth) / 2 : l === "horizontalRight" ? m = Math.min((t.width - window.innerWidth) / 2, z - (f ?? 0)) : m = Math.max(-((t.width - window.innerWidth) / 2), z - (f ?? 0)), t.height <= window.innerHeight ? p = 0 : t.top > 0 ? p = (t.height - window.innerHeight) / 2 : t.bottom < window.innerHeight ? p = -(t.height - window.innerHeight) / 2 : n === "verticalBottom" ? p = Math.min((t.height - window.innerHeight) / 2, T - (u ?? 0)) : p = Math.max(-((t.height - window.innerHeight) / 2), T - (u ?? 0)), {
        offsetX: m,
        offsetY: p
      };
    }
    function A(e) {
      y("mousemove", document, E), y("mouseup", document, A);
      const {
        clientX: o,
        clientY: t
      } = e;
      H = !1;
      const n = Q({
        mouseUpClientX: o,
        mouseUpClientY: t,
        mouseDownClientX: N,
        mouseDownClientY: L
      }), l = V(n);
      g = l.offsetX, x = l.offsetY, h();
    }
    const c = pe(ye, null);
    function ee(e) {
      var o, t;
      if ((t = (o = c == null ? void 0 : c.previewedImgPropsRef.value) === null || o === void 0 ? void 0 : o.onMousedown) === null || t === void 0 || t.call(o, e), e.button !== 0)
        return;
      const {
        clientX: n,
        clientY: l
      } = e;
      H = !0, _ = n - g, B = l - x, z = g, T = x, N = n, L = l, h(), $("mousemove", document, E), $("mouseup", document, A);
    }
    function te(e) {
      var o, t;
      (t = (o = c == null ? void 0 : c.previewedImgPropsRef.value) === null || o === void 0 ? void 0 : o.onDblclick) === null || t === void 0 || t.call(o, e);
      const n = U();
      d = d === n ? 1 : n, h();
    }
    const W = 1.5;
    let C = 0, d = 1, S = 0;
    function X() {
      d = 1, C = 0;
    }
    function oe() {
      var e;
      X(), S = 0, (e = a.onPrev) === null || e === void 0 || e.call(a);
    }
    function ie() {
      var e;
      X(), S = 0, (e = a.onNext) === null || e === void 0 || e.call(a);
    }
    function ne() {
      S -= 90, h();
    }
    function le() {
      S += 90, h();
    }
    function re() {
      const {
        value: e
      } = v;
      if (!e)
        return 1;
      const {
        innerWidth: o,
        innerHeight: t
      } = window, n = Math.max(1, e.naturalHeight / (t - R)), l = Math.max(1, e.naturalWidth / (o - R));
      return Math.max(3, n * 2, l * 2);
    }
    function U() {
      const {
        value: e
      } = v;
      if (!e)
        return 1;
      const {
        innerWidth: o,
        innerHeight: t
      } = window, n = e.naturalHeight / (t - R), l = e.naturalWidth / (o - R);
      return n < 1 && l < 1 ? 1 : Math.max(n, l);
    }
    function ae() {
      const e = re();
      d < e && (C += 1, d = Math.min(e, Math.pow(W, C)), h());
    }
    function se() {
      if (d > 0.5) {
        const e = d;
        C -= 1, d = Math.max(0.5, Math.pow(W, C));
        const o = e - d;
        h(!1);
        const t = V();
        d += o, h(!1), d -= o, g = t.offsetX, x = t.offsetY, h();
      }
    }
    function ce() {
      const e = M.value;
      e && Ae(e, void 0);
    }
    function h(e = !0) {
      var o;
      const {
        value: t
      } = v;
      if (!t)
        return;
      const {
        style: n
      } = t, l = be((o = c == null ? void 0 : c.previewedImgPropsRef.value) === null || o === void 0 ? void 0 : o.style);
      let f = "";
      if (typeof l == "string")
        f = l + ";";
      else
        for (const m in l)
          f += `${Le(m)}: ${l[m]};`;
      const u = `transform-origin: center; transform: translateX(${g}px) translateY(${x}px) rotate(${S}deg) scale(${d});`;
      H ? n.cssText = f + "cursor: grabbing; transition: none;" + u : n.cssText = f + "cursor: grab;" + u + (e ? "" : "transition: none;"), e || t.offsetHeight;
    }
    function j() {
      I.value = !I.value, D.value = !0;
    }
    function de() {
      d = U(), C = Math.ceil(Math.log(d) / Math.log(W)), g = 0, x = 0, h();
    }
    const fe = {
      setPreviewSrc: (e) => {
        M.value = e;
      },
      setThumbnailEl: (e) => {
        r = e;
      },
      toggleShow: j
    };
    function ue(e, o) {
      if (a.showToolbarTooltip) {
        const {
          value: t
        } = b;
        return i(Ee, {
          to: !1,
          theme: t.peers.Tooltip,
          themeOverrides: t.peerOverrides.Tooltip,
          keepAliveOnHover: !1
        }, {
          default: () => G.value[o],
          trigger: () => e
        });
      } else
        return e;
    }
    const F = ge(() => {
      const {
        common: {
          cubicBezierEaseInOut: e
        },
        self: {
          toolbarIconColor: o,
          toolbarBorderRadius: t,
          toolbarBoxShadow: n,
          toolbarColor: l
        }
      } = b.value;
      return {
        "--n-bezier": e,
        "--n-toolbar-icon-color": o,
        "--n-toolbar-color": l,
        "--n-toolbar-border-radius": t,
        "--n-toolbar-box-shadow": n
      };
    }), {
      inlineThemeDisabled: Z
    } = ze(), k = Z ? Te("image-preview", void 0, F, a) : void 0;
    return Object.assign({
      previewRef: v,
      previewWrapperRef: s,
      previewSrc: M,
      show: I,
      appear: He(),
      displayed: D,
      previewedImgProps: c == null ? void 0 : c.previewedImgPropsRef,
      handleWheel(e) {
        e.preventDefault();
      },
      handlePreviewMousedown: ee,
      handlePreviewDblclick: te,
      syncTransformOrigin: J,
      handleAfterLeave: () => {
        X(), S = 0, D.value = !1;
      },
      handleDragStart: (e) => {
        var o, t;
        (t = (o = c == null ? void 0 : c.previewedImgPropsRef.value) === null || o === void 0 ? void 0 : o.onDragstart) === null || t === void 0 || t.call(o, e), e.preventDefault();
      },
      zoomIn: ae,
      zoomOut: se,
      handleDownloadClick: ce,
      rotateCounterclockwise: ne,
      rotateClockwise: le,
      handleSwitchPrev: oe,
      handleSwitchNext: ie,
      withTooltip: ue,
      resizeToOrignalImageSize: de,
      cssVars: Z ? void 0 : F,
      themeClass: k == null ? void 0 : k.themeClass,
      onRender: k == null ? void 0 : k.onRender
    }, fe);
  },
  render() {
    var a, b;
    const {
      clsPrefix: r
    } = this;
    return i(K, null, (b = (a = this.$slots).default) === null || b === void 0 ? void 0 : b.call(a), i(We, {
      show: this.show
    }, {
      default: () => {
        var v;
        return this.show || this.displayed ? ((v = this.onRender) === null || v === void 0 || v.call(this), q(i("div", {
          class: [`${r}-image-preview-container`, this.themeClass],
          style: this.cssVars,
          onWheel: this.handleWheel
        }, i(Y, {
          name: "fade-in-transition",
          appear: this.appear
        }, {
          default: () => this.show ? i("div", {
            class: `${r}-image-preview-overlay`,
            onClick: this.toggleShow
          }) : null
        }), this.showToolbar ? i(Y, {
          name: "fade-in-transition",
          appear: this.appear
        }, {
          default: () => {
            if (!this.show)
              return null;
            const {
              withTooltip: s
            } = this;
            return i("div", {
              class: `${r}-image-preview-toolbar`
            }, this.onPrev ? i(K, null, s(i(w, {
              clsPrefix: r,
              onClick: this.handleSwitchPrev
            }, {
              default: () => Ce
            }), "tipPrevious"), s(i(w, {
              clsPrefix: r,
              onClick: this.handleSwitchNext
            }, {
              default: () => Se
            }), "tipNext")) : null, s(i(w, {
              clsPrefix: r,
              onClick: this.rotateCounterclockwise
            }, {
              default: () => i(Xe, null)
            }), "tipCounterclockwise"), s(i(w, {
              clsPrefix: r,
              onClick: this.rotateClockwise
            }, {
              default: () => i(Ye, null)
            }), "tipClockwise"), s(i(w, {
              clsPrefix: r,
              onClick: this.resizeToOrignalImageSize
            }, {
              default: () => i($e, null)
            }), "tipOriginalSize"), s(i(w, {
              clsPrefix: r,
              onClick: this.zoomOut
            }, {
              default: () => i(_e, null)
            }), "tipZoomOut"), s(i(w, {
              clsPrefix: r,
              onClick: this.zoomIn
            }, {
              default: () => i(Be, null)
            }), "tipZoomIn"), s(i(w, {
              clsPrefix: r,
              onClick: this.handleDownloadClick
            }, {
              default: () => ke
            }), "tipDownload"), s(i(w, {
              clsPrefix: r,
              onClick: this.toggleShow
            }, {
              default: () => Pe
            }), "tipClose"));
          }
        }) : null, i(Y, {
          name: "fade-in-scale-up-transition",
          onAfterLeave: this.handleAfterLeave,
          appear: this.appear,
          // BUG:
          // onEnter will be called twice, I don't know why
          // Maybe it is a bug of vue
          onEnter: this.syncTransformOrigin,
          onBeforeLeave: this.syncTransformOrigin
        }, {
          default: () => {
            const {
              previewedImgProps: s = {}
            } = this;
            return q(i("div", {
              class: `${r}-image-preview-wrapper`,
              ref: "previewWrapperRef"
            }, i("img", Object.assign({}, s, {
              draggable: !1,
              onMousedown: this.handlePreviewMousedown,
              onDblclick: this.handlePreviewDblclick,
              class: [`${r}-image-preview`, s.class],
              key: this.previewSrc,
              src: this.previewSrc,
              ref: "previewRef",
              onDragstart: this.handleDragStart
            }))), [[xe, this.show]]);
          }
        })), [[Ne, {
          enabled: this.show
        }]])) : null;
      }
    }));
  }
});
export {
  mt as default
};
